@if (value === null || value === undefined) {
    <div class="jpv-empty">null</div>
} @else if (isObject(value)) {
    @for (k of objectKeys(value); track k) {
        @let childPath = pathChild(path, k);
        @let childIsContainer = !isLeaf(value[k]);
        @let childCollapsed = isCollapsed(childPath);
        <div class="jpv-line"
             [class.jpv-highlighted]="highlightedPath === childPath"
             [class.jpv-container-line]="childIsContainer"
             [attr.data-path]="childPath"
             (click)="nodeClick.emit(childPath); $event.stopPropagation()">
            @if (childIsContainer) {
                <span class="jpv-toggle"
                      [class.jpv-toggle-collapsed]="childCollapsed"
                      (click)="toggleCollapse(childPath, $event)">▾</span>
            } @else {
                <span class="jpv-toggle-spacer"></span>
            }
            <span class="jpv-key">{{ k }}</span><span class="jpv-sep">:</span>
            @if (isLeaf(value[k])) {
                <span class="jpv-val" [class]="'jpv-t-' + leafType(value[k])">{{ formatLeaf(value[k]) }}</span>
            } @else if (childCollapsed) {
                <span class="jpv-summary">{{ containerSummary(value[k]) }}</span>
            } @else {
                <app-json-path-viewer class="jpv-nested"
                                       [value]="value[k]"
                                       [path]="childPath"
                                       [highlightedPath]="highlightedPath"
                                       (nodeClick)="nodeClick.emit($event)" />
            }
        </div>
    }
} @else if (isArray(value)) {
    @for (item of value; track $index; let i = $index) {
        @let idxPath = pathIndex(path, i);
        @let itemIsContainer = !isLeaf(item);
        @let itemCollapsed = isCollapsed(idxPath);
        <div class="jpv-line"
             [class.jpv-highlighted]="highlightedPath === idxPath"
             [class.jpv-container-line]="itemIsContainer"
             [attr.data-path]="idxPath"
             (click)="nodeClick.emit(idxPath); $event.stopPropagation()">
            @if (itemIsContainer) {
                <span class="jpv-toggle"
                      [class.jpv-toggle-collapsed]="itemCollapsed"
                      (click)="toggleCollapse(idxPath, $event)">▾</span>
            } @else {
                <span class="jpv-toggle-spacer"></span>
            }
            <span class="jpv-idx">{{ i }}</span><span class="jpv-sep">:</span>
            @if (isLeaf(item)) {
                <span class="jpv-val" [class]="'jpv-t-' + leafType(item)">{{ formatLeaf(item) }}</span>
            } @else if (itemCollapsed) {
                <span class="jpv-summary">{{ containerSummary(item) }}</span>
            } @else {
                <app-json-path-viewer class="jpv-nested"
                                       [value]="item"
                                       [path]="idxPath"
                                       [highlightedPath]="highlightedPath"
                                       (nodeClick)="nodeClick.emit($event)" />
            }
        </div>
    }
} @else {
    <span class="jpv-val" [class]="'jpv-t-' + leafType(value)">{{ formatLeaf(value) }}</span>
}
